import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/reports`;

export const reportInMeeting = async (reportedId, meetingId, content) => {
    const response = await axios.post(`${API_BASE_URL}/on-meeting`, {
        reportedId: reportedId,
        meetingId: meetingId,
        content: content
    });
    return response.data;
};

export const reportOutOfMeeting = async (reportedId, meetingId, content) => {
    const response = await axios.post(`${API_BASE_URL}/out-of-meeting`, {
        reportedId: reportedId,
        meetingId: meetingId,
        content: content
    });
    return response.data;
};